/* TWRD: linjelisten skal vise praecis det /cart.js siger.
 *
 * Shopify DELER en linje op naar en automatisk rabat kun daekker et
 * stykke. "PAIR UP · TEE + SWEATPANTS BUNDLE" giver rabat paa EEN tee, saa
 * et tryk paa "+" giver to linjer af samme variant med hver sin noegle: en
 * til parpris og en til fuld pris. Samme vej tilbage laegges de sammen
 * igen. Det er Shopify-adfaerd, ogsaa paa det live tema.
 *
 * Temaets <cart-items> (assets/cart-components.js) flytter og bygger selv
 * linjer om, men ud fra SIN EGEN liste over noegler. Naar den liste kommer
 * ud af trit med kurven, bliver den nye linje aldrig sat ind: paa /cart var
 * badge og totaler rigtige, mens listen stod med to linjer selv om /cart.js
 * havde tre.
 *
 * Her afstemmes DOM'en med den kurv vi lige har faaet eller hentet:
 *   - linjer med en noegle kurven ikke kender fjernes
 *   - dubletter af samme noegle fjernes
 *   - manglende linjer bygges af temaets egen
 *     <template id="template-cart-item">, saa <cart-item> selv tegner
 *     titel, billede, pris og rabatraekke og binder +, − og REMOVE til SIN
 *     egen noegle
 *   - raekkefoelgen rettes til kurvens
 *
 * To linjer af samme variant ved siden af hinanden er det rigtige billede.
 * Det er sandt: den ene koster parpris, den anden fuld pris. De bliver
 * derfor staaende hver for sig og bliver ikke lagt sammen visuelt.
 *
 * Gaelder baade skuffen og /cart: der soeges paa alle <cart-items> paa
 * siden. Afstemningen sker KUN med en kurv vi lige har faaet eller hentet,
 * aldrig ud fra en mutation. En gammel kurv maatte ikke kunne fjerne en
 * linje der netop er kommet.
 */
(function () {
  'use strict';

  if (window.__twrdCartLines) return;
  window.__twrdCartLines = true;

  var CART_URL = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart.js';
  var MAX_RETRIES = 6;
  var retries = 0;

  function reconcile(cart) {
    if (!cart || !cart.items) return false;
    var lists = document.querySelectorAll('cart-items');
    if (!lists.length) return false;
    var tpl = document.getElementById('template-cart-item');

    var wanted = {};
    var i;
    for (i = 0; i < cart.items.length; i += 1) wanted[cart.items[i].key] = true;

    var changed = false;
    var incomplete = false;

    for (var l = 0; l < lists.length; l += 1) {
      var list = lists[l];
      var seen = {};
      var nodes = list.querySelectorAll('cart-item');
      for (i = 0; i < nodes.length; i += 1) {
        var node = nodes[i];
        var key = node.getAttribute('key');
        if (!key || !wanted[key] || seen[key]) {
          if (node.parentNode) node.parentNode.removeChild(node);
          changed = true;
        } else {
          seen[key] = node;
        }
      }

      var prev = null;
      for (i = 0; i < cart.items.length; i += 1) {
        var item = cart.items[i];
        var el = seen[item.key];
        if (!el) {
          if (!tpl) continue;
          el = tpl.content.cloneNode(true).querySelector('cart-item');
          if (!el) continue;
          el.setAttribute('key', item.key);
          changed = true;
        }
        if (prev) {
          if (prev.nextElementSibling !== el) {
            prev.parentNode.insertBefore(el, prev.nextElementSibling);
            changed = true;
          }
        } else if (list.firstElementChild !== el) {
          list.insertBefore(el, list.firstElementChild);
          changed = true;
        }
        /* <cart-item> tegner sig selv ud af temaets kurv-lager, ikke ud af
           den kurv vi lige hentede. Kender lageret endnu ikke noeglen,
           tegner elementet intet og abonnerer aldrig: en tom linje der ikke
           kan hele sig selv. Den fjernes derfor igen, og vi proever forfra
           om et oejeblik, naar lageret er fulgt med. Elementet tegner sig i
           connectedCallback, saa svaret staar klar lige efter indsaettelsen. */
        if (!el.hasAttribute('rendered')) {
          if (el.parentNode) el.parentNode.removeChild(el);
          incomplete = true;
          continue;
        }
        prev = el;
      }
    }

    if (incomplete && retries < MAX_RETRIES) {
      retries += 1;
      window.setTimeout(function () { reconcile(cart); }, 300 * retries);
    } else if (!incomplete) {
      retries = 0;
    }

    if (changed) {
      /* Kroge der pynter linjerne (titler, Remove-linket, skriftstedet,
         opsummeringen) haenger paa denne. De er alle idempotente. */
      document.dispatchEvent(new CustomEvent('twrd:cart-lines', { detail: { cart: cart } }));
    }
    return changed;
  }

  function verify() {
    window
      .fetch(CART_URL, { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (cart) { if (cart) reconcile(cart); })
      .catch(function () {});
  }

  /* on:cart:loaded baerer den autoritative nye kurv ved add, change, remove
     og refresh. Temaets lager er opdateret, foer eventet sendes, saa samme
     kurv kan bruges igen ved en sjælden forsinket custom-element render. */
  document.addEventListener('on:cart:loaded', function (e) {
    var cart = e && e.detail && e.detail.cart;
    retries = 0;
    if (cart && cart.items) reconcile(cart);
  });

  /* Safari fryser en skjult fane og genbruger siden fra bfcache. Begge veje
     tilbage skal ende i en kontrol, ellers staar listen som foer pausen. */
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) verify();
  });
  window.addEventListener('pageshow', function (e) { if (e.persisted) verify(); });
})();
